import moment from 'moment-timezone';
import { environment } from 'environments';

(() => {
  const VisitMessagesController = function ($log, $scope, $timeout, toastr, Notifications, Orders, Messages) {
    'ngInject';

    const self = this;
    self.patient = Orders.current.user;
    self.test = 'test';

    function _load() {
      self.loading = true;
      Messages.getThread(self.patient.id)
        .then(({ data }) => {
          // $log.log('Order Messages :', data);
          self.messages = data.data;

          if (data.metadata && data.metadata.num_unread_from && data.metadata.num_unread_from > 0) {
            self.hasUnreadMessages = true;
          } else {
            self.hasUnreadMessages = false;
          }
        })
        .catch(err => {
          self.hasUnreadMessages = false;
        })
        .finally(() => {
          self.loading = false;
        });
    }

    self.addMessage = content => {
      if (content.trim()) {
        self.messages.unshift({
          content,
          sent_at: new Date(),
          from: {
            id: -1,
            name: 'Lemonaid',
            tag: 'system',
          },
        });
      }
    };

    $scope.$on('messages:pulled', (event, data) => {
      if (data && data.num_unread_from && data.num_unread_from > 0) {
        self.hasUnreadMessages = true;
      } else {
        self.hasUnreadMessages = false;
      }
    });
    $scope.$on('chat-popup:closed', () => {
      // BEFORE REFRESHING
      // WE WAIT FIRST FOR ANY UPDATE TO FINISH
      $timeout(() => {
        _load();
      }, 1000);
    });
    $scope.$on('pharmacy:updated', () => _load());
    $scope.$on('visit:denied', () => _load());
    $scope.$on('visit:completed', () => _load());
    $scope.$on('payment:error', () => _load());
    $scope.$on('photos:updated', (event, approved) => {
      if (!approved) {
        _load();
      }
    });

    self.formatDate = function formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    };

    _load();
  };

  VisitMessagesController.$inject = ['$log', '$scope', '$timeout', 'toastr', 'Notifications', 'Orders', 'Messages'];
  angular.module('pims').component('patientMessages', {
    templateUrl: 'app/components/patient-messages/patient-messages.html',
    controller: VisitMessagesController,
    bindings: {
      visit: '<',
      patient: '<',
      hasUnreadMessages: '=',
      timezone: '=',
    },
  });
})();
